import ProductsConfiguratorPage from './ProductsConfiguratorPage';

export default ProductsConfiguratorPage;
